import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon, Clock3Icon, ShieldCheckIcon, StarIcon } from 'lucide-react';
import { Badge } from '../Badge';
import { CtaButton } from '../CtaButton';
import { Logo } from '../Logo';
import { BeforeAfterSlider } from '../BeforeAfterSlider';
import { BEFORE_AFTER } from '../../lib/content';
const STATS = [{
  value: '4.9',
  label: 'Avg patient rating',
  star: true
}, {
  value: '250+',
  label: 'Smiles transformed',
  star: false
}, {
  value: '12 years',
  label: 'Premium full-arch experience',
  star: false
}];
export function Hero() {
  const [caseIndex, setCaseIndex] = useState(0);
  const activeCase = BEFORE_AFTER[caseIndex];
  return <section className="relative w-full overflow-hidden bg-white" data-id="element-85" data-mp="10knk87jkoxlf">
      <div className="pointer-events-none absolute inset-0" aria-hidden="true" data-id="element-86" data-mp="15ll20j0o7pme">
        <div className="absolute -top-32 -right-24 h-96 w-96 rounded-full bg-[#A9DFE9]/40 blur-3xl" data-id="element-87" data-mp="1aj3bcailo6ux" />
        <div className="absolute top-1/2 -left-32 h-80 w-80 rounded-full bg-[#26B3CA]/15 blur-3xl" data-id="element-88" data-mp="9o2rvr4dz0pp" />
      </div>

      <div className="relative mx-auto flex max-w-6xl items-center justify-between px-6 py-6" data-id="element-89" data-mp="4nogbz3kt8mx">
        <Logo size="md" aria-label="Pler Smile home" data-id="element-90" data-mp="3vw2cuusicuqd" />
        <div className="hidden items-center gap-2 text-sm font-semibold text-[#1F6E7B] sm:flex" data-id="element-91" data-mp="3vwu5pxuq0ecy">
          <ShieldCheckIcon size={16} data-id="element-92" data-mp="3rvs7nkcji8ck" />
          Dadeland, Kendall, Miami
        </div>
      </div>

      <div className="relative mx-auto grid max-w-6xl grid-cols-1 items-center gap-12 px-6 pb-16 pt-6 lg:grid-cols-2 lg:pb-24 lg:pt-10" data-id="element-93" data-mp="sg4zkcz1v6nt">
        <motion.div className="flex flex-col" initial={{
        opacity: 0,
        y: 26
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-94" data-mp="inph7ejucg2e">
          <div className="mb-6 flex flex-wrap gap-2" data-id="element-95" data-mp="1b6378ryxqxqx">
            <Badge variant="aqua" size="sm" className="landing-badge" data-id="element-96" data-mp="16djt9twc60ll">All-on-X Dental Implants</Badge>
            <Badge variant="sky" size="sm" className="landing-badge" data-id="element-97" data-mp="30lnn8la5g1qh">Pler Smile Dadeland</Badge>
            <Badge variant="outline" size="sm" className="landing-badge" data-id="element-98" data-mp="35ljqujexpr5i">5-Day Smile Experience</Badge>
          </div>

          <div className="mb-5 inline-flex w-fit items-center gap-2 rounded-full bg-[#1A1A2E] px-4 py-2 text-sm font-semibold text-white" data-id="element-99" data-mp="2qv2uheh5prfh">
            <Clock3Icon size={16} className="text-[#A9DFE9]" data-id="element-100" data-mp="2vt4d5yao7oqf" />
            Only 3 clinical openings remain this month
          </div>

          <h1 className="text-4xl font-bold leading-[1.05] tracking-tight text-[#1A1A2E] md:text-5xl lg:text-6xl" data-id="element-101" data-mp="2mv22er14xhpy">
            When did smiling become something you avoid?
            <span className="mt-2 block text-[#1F6E7B]" data-id="element-102" data-mp="27zmg586sqq44">5 days in Miami and your smile comes back!!</span>
          </h1>

          <p className="mt-6 max-w-xl text-lg leading-relaxed text-[#1A1A2E]/80" data-id="element-103" data-mp="66513jgc6mzc">
            Complete All-on-X surgery with 3D facial design, four hotel nights, and airport transportation included. {' '}
            <span className="font-bold text-[#1A1A2E]" data-id="element-104" data-mp="1vmhcamh8jmon">Your final zirconia smile is waiting</span>.
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-105" data-mp="1qoyzum40epbw">
            <CtaButton data-id="element-106" data-mp="25dbyxrye8oam" />
          </div>

          <dl className="mt-8 grid grid-cols-3 rounded-2xl bg-[#A9DFE9]/20 px-2 py-5 text-center sm:px-4" data-id="element-107" data-mp="25eembpwic8ls">
            {STATS.map((stat, index) => <div key={stat.label} className={index > 0 ? 'border-l border-[#1A1A2E]/15 px-2 sm:px-4' : 'px-2 sm:px-4'} data-id="element-108" data-mp="2edi8x3uvv651" data-mpi={index}>
                <dd className="flex items-center justify-center gap-1 text-2xl font-bold tracking-tight text-[#1A1A2E] sm:text-3xl" data-id="element-109" data-mp="2acg7cgdhuhzw">
                  {stat.value}
                  {stat.star ? <StarIcon size={20} className="fill-[#26B3CA] text-[#26B3CA]" aria-hidden="true" data-id="element-110" data-mp="2jcldkn6ybach" /> : null}
                </dd>
                <dt className="mt-1 text-[10px] font-semibold uppercase tracking-[0.12em] text-[#1A1A2E]/65 sm:text-xs" data-id="element-111" data-mp="twvgdprjlrjj">{stat.label}</dt>
              </div>)}
          </dl>
        </motion.div>

        <motion.div className="relative" initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.1,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-112" data-mp="qg92c7ex1vwf">
          <AnimatePresence mode="wait" data-id="element-113" data-mp="10bu72dbdda9v">
            <motion.div key={activeCase.name} initial={{
            opacity: 0,
            x: 24
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -24
          }} transition={{
            duration: 0.35,
            ease: [0.22, 1, 0.36, 1]
          }} data-id="element-114" data-mp="15djivv6f1rz0">
              <BeforeAfterSlider before={activeCase.before} after={activeCase.after} label={activeCase.name} detail={activeCase.detail} data-id="element-115" data-mp="hluq6dpon1hj" />
            </motion.div>
          </AnimatePresence>

          <div className="mt-5 flex items-center justify-between gap-4" data-id="element-116" data-mp="3l3cw2flw9yfb">
            <button type="button" onClick={() => setCaseIndex(current => (current - 1 + BEFORE_AFTER.length) % BEFORE_AFTER.length)} aria-label="Previous patient case" className="flex h-11 w-11 items-center justify-center rounded-full border border-[#A9DFE9] bg-white text-[#1F6E7B] transition hover:bg-[#1F6E7B] hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#1F6E7B] focus-visible:ring-offset-2" data-id="element-117" data-mp="3q2fpt3wfci7z">
              <ChevronLeftIcon size={20} aria-hidden="true" data-id="element-118" data-mp="1t83h34fnmimz" />
            </button>

            <div className="flex items-center gap-2" role="tablist" aria-label="Patient cases" data-id="element-119" data-mp="1oa1x8haemfag">
              {BEFORE_AFTER.map((item, i) => <button key={item.name} type="button" role="tab" aria-selected={i === caseIndex} aria-label={`Show ${item.name}`} onClick={() => setCaseIndex(i)} className={`h-1.5 rounded-full transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#1F6E7B] focus-visible:ring-offset-2 ${i === caseIndex ? 'w-10 bg-[#1F6E7B]' : 'w-4 bg-[#A9DFE9] hover:bg-[#1F6E7B]/50'}`} data-id="element-120" data-mp="1jgfj0kole3cj" data-mpi={i} />)}
            </div>

            <button type="button" onClick={() => setCaseIndex(current => (current + 1) % BEFORE_AFTER.length)} aria-label="Next patient case" className="flex h-11 w-11 items-center justify-center rounded-full border border-[#A9DFE9] bg-white text-[#1F6E7B] transition hover:bg-[#1F6E7B] hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#1F6E7B] focus-visible:ring-offset-2" data-id="element-121" data-mp="qwbrd6cpd4ah">
              <ChevronRightIcon size={20} aria-hidden="true" data-id="element-122" data-mp="19m1ow17uo463" />
            </button>
          </div>
        </motion.div>
      </div>
    </section>;
}